__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@com.q4inc.connect.platform/platform-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.14.1", () => (Promise.all([__webpack_require__.e(9575), __webpack_require__.e(1188), __webpack_require__.e(7799), __webpack_require__.e(6895)]).then(() => (() => (__webpack_require__(11956))))));
			register("@datadog/browser-logs", "4.50.1", () => (Promise.all([__webpack_require__.e(9081), __webpack_require__.e(266)]).then(() => (() => (__webpack_require__(70266))))));
			register("@q4/platform-client-sdk-localization", "0.112.0", () => (Promise.all([__webpack_require__.e(9387), __webpack_require__.e(3278), __webpack_require__.e(7799), __webpack_require__.e(2930), __webpack_require__.e(4334)]).then(() => (() => (__webpack_require__(13278))))));
			register("@q4/platform-client-sdk-messaging", "0.96.0", () => (Promise.all([__webpack_require__.e(7445), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(7445))))));
			register("graphql", "16.14.2", () => (__webpack_require__.e(1547).then(() => (() => (__webpack_require__(91547))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))));
			register("posthog-js", "1.444.0", () => (__webpack_require__.e(4992).then(() => (() => (__webpack_require__(14992))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(32389))))));
			register("react", "18.2.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(92168);
			initExternal(93562);
			initExternal(32229);
			initExternal(70431);
			initExternal(31456);
			initExternal(33572);
			initExternal(40192);
			initExternal(23091);
			initExternal(49368);
			initExternal(62881);
			initExternal(50649);
			initExternal(66720);
			initExternal(50717);
			initExternal(56139);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};